export default {
  completed: 'completed',
  intro: 'intro',
  saving: 'saving',
  submitted: 'submitted',
  emailVerified: 'emailVerified'
}
